export enum STAT_GROUPS {
  sessionsCompleted = "sessionsCompleted",
  studyDuration = "studyDuration",
  averageScore = "averageScore",
  sessionModulesCorrect = "sessionModulesCorrect",
  sessionModulesStudied = "sessionModulesStudied",
  sessionModulesIncorrect = "sessionModulesIncorrect"
}
